import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminUsersOverview() {
    return useQuery({
        queryKey: adminKeys.usersOverview(),
        queryFn: () => adminApi.getUsersOverview(),
    });
}
